import { render } from "./VFileList.vue?vue&type=template&id=11861a4a"
import script from "./VFileList.vue?vue&type=script&lang=js"
export * from "./VFileList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__